import React from 'react'
import AddBeneficiaryForm from '../../components/Beneficiary/AddBeneficiaryForm'


const AddBeneficiary = () => {
  return (
    <div>
      <AddBeneficiaryForm/>
    </div>
  )
}

export default AddBeneficiary
